import { ethereum } from '@0xtorch/core'
import { zksync } from 'viem/chains'
import { type Client, createClient } from '../../client'
import type { Explorer } from '../../explorer'
import { createBlockscout } from '../../explorer'
import type { Chain } from '../types/chain'
import type { HttpRpc } from '../types/rpc'

type CreateZkSyncEraChainParameters = {
  client: Client
  explorer: Explorer
}

export const createZkSyncEraChain = ({
  explorerProxyUrl: proxyUrl,
}: {
  explorerProxyUrl?: string
}): Chain =>
  createZkSyncEraChainCustom({
    client: createClient({
      chain: zksync,
      httpRpcs: zksyncEraHttpRpcs,
    }),
    explorer: createBlockscout({
      useAddressApiV2: true,
      name: 'zkSync Era Explorer',
      baseUrl: 'https://zksync.blockscout.com',
      apiBaseUrl: 'https://zksync.blockscout.com/api',
      proxyUrl,
    }),
  })

export const createZkSyncEraChainCustom = ({
  client,
  explorer,
}: CreateZkSyncEraChainParameters): Chain => ({
  id: 324,
  network: 'zksync-era',
  name: 'zkSync Era',
  nativeToken: {
    name: 'Ethereum',
    symbol: 'ETH',
    decimals: 18,
    currency: ethereum,
  },
  wrappedTokenAddresses: new Set([
    '0x5aea5775959fbc2557cc8789bc1bf90a239d9a91',
  ]),
  explorer,
  client,
  blockTime: 1000,
  coingeckoId: 'zksync',
  defillamaId: undefined,
})

export const zksyncEraHttpRpcs: HttpRpc[] = [
  {
    url: 'https://mainnet.era.zksync.io',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
  // Endpoint is not working
  // {
  //   url: 'https://zksync-era.blockpi.network/v1/rpc/public',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 1024n,
  // },
  // Not archiving receipts
  // {
  //   url: 'https://go.getblock.io/f76c09905def4618a34946bf71851542',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 10_000n,
  // },
  // Not archiving receipts
  // {
  //   url: 'https://zksync.meowrpc.com',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 1024n,
  // },
  // Not archiving receipts
  // {
  //   url: 'https://zksync.drpc.org',
  //   getLogsIsUsable: false,
  //   getLogsMaxBlockRange: 0n,
  // },
  {
    url: 'https://1rpc.io/zksync2-era',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 1000n,
  },
  // Endpoint is not working
  // {
  //   url: 'https://endpoints.omniatech.io/v1/zksync-era/mainnet/public',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 10_000n,
  // },
  // Not archiving receipts
  // {
  //   url: 'https://api.zan.top/zksync-mainnet',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 10_000n,
  // },
]

export const zksyncEraWebsocketRpcUrls: readonly string[] = []
